export default __webpack_public_path__ + "static/media/landing-page-bg.9f6d1d2a.png";